/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 *
 * Resilient wrapper: on API/backend failure returns [] so breadcrumb does not crash the page.
 */
/// <reference path="../typings/retail-actions-subpaths.d.ts" />

import {
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext,
    IGeneric,
    IAny
} from '@msdyn365-commerce/core';
import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';
import {
    createCategoriesHierarchyInput,
    getCurrentCategoryHierarchyAction
} from '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';

/**
 * Safe wrapper: call the real action, and fallback to [] on failure.
 */
export async function getCurrentCategoryHierarchySafeAction(input: IActionInput, ctx: IActionContext): Promise<CategoryHierarchy[]> {
    try {
        return await getCurrentCategoryHierarchyAction(input, ctx);
    } catch (error) {
        ctx.telemetry?.warning?.(
            `[get-current-category-hierarchy-safe] Backend call failed; returning empty hierarchy. Error: ${
                error instanceof Error ? error.message : String(error)
            }`
        );
        return [];
    }
}

export const getCurrentCategoryHierarchySafeDataAction = createObservableDataAction({
    id: 'get-current-category-hierarchy-safe',
    action: getCurrentCategoryHierarchySafeAction as IAction<CategoryHierarchy[]>,
    input: createCategoriesHierarchyInput as (inputData: ICreateActionContext<IGeneric<IAny>>) => IActionInput
});

export default getCurrentCategoryHierarchySafeDataAction;
